import { render, staticRenderFns } from "./ConversationAnswerForm.vue?vue&type=template&id=5d013c24"
import script from "./ConversationAnswerForm.vue?vue&type=script&lang=js"
export * from "./ConversationAnswerForm.vue?vue&type=script&lang=js"
import style0 from "./ConversationAnswerForm.vue?vue&type=style&index=0&id=5d013c24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports